var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-header-minicart" }, [
    _c(
      "a",
      {
        staticClass: "c-btn",
        class: { "is-active": _vm.isOpen },
        attrs: { href: "/nakupny-kosik", "data-quantity": _vm.count },
        on: { click: _vm.handleMinicartClick },
      },
      [
        _vm.isInitialized && !_vm.isEmpty
          ? _c("span", { staticClass: "c-badge is-primary" }, [
              _vm._v(_vm._s(_vm.count)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("i", {
          staticClass: "ico ico-shopping-cart",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "sc-price",
          domProps: {
            innerHTML: _vm._s(
              _vm.formatPrice(
                _vm.pricesWithVat ? _vm.totalPrice : _vm.subtotalPrice
              )
            ),
          },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.isOpen
      ? _c(
          "div",
          {
            class: {
              "c-minicart": true,
              "is-loading": _vm.isLoading,
            },
          },
          [
            _c(
              "div",
              { staticClass: "c-minicart__products-wrapper" },
              [
                _c("div", { staticClass: "c-minicart__header" }, [
                  _c("div", { staticClass: "is-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("Minicart.Header.title")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isInitialized && !_vm.isEmpty
                    ? _c("div", { staticClass: "c-msg c-msg--success" }, [
                        _c("i", { staticClass: "ico ico-deliver-car" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.freeShippingText) },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isInitialized
                  ? [
                      !_vm.isEmpty
                        ? _c(
                            "div",
                            { staticClass: "c-minicart__products" },
                            [
                              _vm._l(_vm.products, function (item) {
                                return [
                                  item.bundleId
                                    ? _c("minicart-custom-bundle", {
                                        key: `minicart_bundle_${item.bundleId}`,
                                        attrs: { item: item },
                                        on: { remove: _vm.removeBundle },
                                      })
                                    : _c("minicart-item", {
                                        key: `minicart_item_${item.cart_id}`,
                                        attrs: {
                                          item: item,
                                          isUpdatingQuantity:
                                            _vm.updatingQuantity[item.cart_id],
                                        },
                                        on: {
                                          remove: _vm.removeItem,
                                          spinningQuantity:
                                            _vm.spinningQuantity,
                                          updateQuantity: _vm.updateQuantity,
                                        },
                                      }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _c("div", { staticClass: "c-minicart__empty" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("Minicart.emptyText")) +
                                "\n                "
                            ),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.isInitialized && !_vm.isEmpty
              ? _c("div", { staticClass: "c-minicart__subtotal" }, [
                  _c("div", { staticClass: "c-minicart-subtotal" }, [
                    _c("div", { staticClass: "c-minicart-subtotal__item" }, [
                      _c(
                        "span",
                        { staticClass: "c-minicart-subtotal__key is-bigger" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.pricesWithVat
                                  ? _vm.$t("Minicart.priceWithVat")
                                  : _vm.$t("Minicart.priceWithoutVat")
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "c-minicart-subtotal__value is-bigger",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.formatPrice(
                              _vm.pricesWithVat
                                ? _vm.totalPrice
                                : _vm.subtotalPrice
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.savings > 0
                      ? _c(
                          "div",
                          { staticClass: "c-minicart-subtotal__item h-is-red" },
                          [
                            _c(
                              "span",
                              { staticClass: "c-minicart-subtotal__key" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("Minicart.savings")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "c-minicart-subtotal__value",
                              domProps: {
                                innerHTML: _vm._s(_vm.formatPrice(_vm.savings)),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "c-btn c-btn--cart",
                      attrs: {
                        href: "/nakupny-kosik",
                        title: _vm.$t("Minicart.proceedToCheckout"),
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Minicart.proceedToCheckout")) +
                          "\n                "
                      ),
                      _c("i", {
                        staticClass: "ico ico-arrow-right",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }